<template>
  <div class="container-fluid">
    <!-- <div class="row">
         <div class="col-12 mx-auto red-line py-2 px-0"></div>
         </div>-->
    <div class="row px-0 px-md-2 my-4 back-txt">
      <div class="col-6">
        <router-link to="/">
          <span class="mr-1">&#8249;</span>Go back to movie list
        </router-link>
      </div>
      <!-- <div class="col-6">
            <router-link class="float-right mt-2 gogo-text" to="">View Screening Detail<span class="ml-1">&#8250;</span>
            </router-link>
            </div>-->
    </div>
    <div class="col-12 mb-3">
      <div class="row">
        <!-- TICKET START -->
        <div
          class="col-md-6 col-lg-3 p-3 p-xl-3 cs-scr-ticket h-75 mx-auto mb-5 mb-lg-0"
        >
          <div class="d-flex">
            <div
              class="col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"
            >
              <img
                v-lazy="movieDetails.md_thumbnail_url"
                class="img-fluid"
                style="border-radius: 7px;"
              />
            </div>
            <div class="d-flex flex-column justify-content-between pl-3">
              <div>
                <p class="mb-1">{{ movieDetails.mc_title }}</p>
                <ul class="list-inline movie-tickDetails">
                  <li
                    class="list-inline-item"
                    v-if="movieDetails.mrrdr_runtime"
                  >
                    {{ movieDetails.mrrdr_runtime }} mins
                  </li>
                  <li
                    class="list-inline-item"
                    v-if="movieDetails.mrrdr_release_date_year"
                  >
                    {{ movieDetails.mrrdr_release_date_year }}
                  </li>
                  <li class="list-inline-item" v-if="LangFormat">
                    {{ LangFormat }}
                  </li>
                  <!-- <li class="list-inline-item">{{movieDetails.Rated}}</li> -->
                </ul>
              </div>
              <div>
                <!-- <p class="rt-txt1">
                  <span class="d-block small">IMDB</span>
                  {{ movieDetails.IMDBRating }}
                </p> -->
                <p class="rt-txt2">
                  <span class="d-block small">Rating</span>
                  {{ movieDetails.rating }}
                </p>
              </div>
            </div>
          </div>
          <hr class="topLine my-2" />
          <!-- CINEMA NAME -->
          <div
            :class="{ hide: Object.entries(selectedCinemaObject).length === 0 }"
          >
            <small class="vCont">
              Cinema:
              <router-link
                @click.native="onChangeCinema()"
                class="hCont"
                v-b-toggle.accordion1
                to="#"
                >(Change)</router-link
              >
            </small>
            <p class="hCont">
              {{ selectedCinemaObject.cinema_name }},
              {{ selectedCinemaObject.cinema_address }}
              {{
                selectedCinemaObject.cinema_location
                  ? `, ${selectedCinemaObject.cinema_location}`
                  : selectedCinemaObject.cinema_location
              }}
            </p>
            <small class="vCont">
              Screen:
              <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
            </small>
            <p class="hCont">{{ ScreenName }}</p>
          </div>
          <!-- DATE AND TIME -->
          <div :class="{ hide: selectedTime.length === 0 }">
            <small class="vCont">
              Date &amp; Time:
              <!-- <router-link
                        @click.native="onChangeDateTime()"
                        v-b-toggle.accordion2
                        class="hCont"
                        to="#"
                        >(Change)</router-link> -->
            </small>
            <ul class="list-inline dateTime hCont">
              <li class="list-inline-item">
                {{ showDetails.month }} {{ showDetails.date }},
                {{ showDetails.year }}
              </li>
              <li class="list-inline-item">|</li>
              <li class="list-inline-item">{{ timeFormat(selectedTime) }}</li>
            </ul>
          </div>
          <!-- SCREENING TYPE -->

         
          <div :class="{ hide: ScreeningType.length === 0 }">
            <small class="vCont">
              Screening Type:
              <!-- <router-link
                        @click.native="onChangeScreeningType()"
                        v-b-toggle.accordion3
                        class="hCont"
                        to="#"
                        >(Change)</router-link
                        > -->
            </small>
            <p class="hCont">{{ ScreeningType }}</p>
          </div>


           <div :class="{ hide: ScreeningType.length === 0 }">
            <small class="vCont">
             {{ selectedCinemaObject.text_desc }}
              <!-- <router-link
                        @click.native="onChangeScreeningType()"
                        v-b-toggle.accordion3
                        class="hCont"
                        to="#"
                        >(Change)</router-link
                        > -->
            </small>
          </div>
          <!-- SELECTED SEATS -->
          <div
            v-if="ScreeningType !== 'Private Screening'"
            :class="{ hide: selectedSeats.length === 0 }"
            class
          >
            <small class="vCont">
              Pick Seats:
              <!-- <router-link v-on:click.native="onEdit()" class="hCont" to="#"
                        >(Change)</router-link
                        > -->
            </small>
            <ul class="list-inline seatList">
              <!-- <li
                v-for="(singleSeat, singleSeatIndex) in pickSeats"
                :key="singleSeatIndex"
                class="list-inline-item"
              >
                {{ singleSeat.sl_seat_name }}
              </li> -->
              <li class="list-inline-item">
                {{ pickSeats }}
              </li>
              <!-- <li class="list-inline-item">L2</li>
                        <li class="list-inline-item">L3</li>
                        <li class="list-inline-item">L4</li>-->
            </ul>
          </div>
          <!-- TICKETS AND PROMO CODE DETAILS -->
          <div
            :class="{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }"
            class="amount-box my-4"
            v-if="parseInt(totalAmountPrice) > 0"
          >
            <div class="ticketAmount">
              <div class="d-flex justify-content-between">
                <p>
                  <span
                    >Tickets ({{
                      this.$store.getters.SELECTED_SEATS.length
                    }}</span
                  >) :
                </p>
                <p v-if="this.$store.getters.SELECTED_SEATS.length > 0">
                  {{ curr_code }} {{ currFormat(totalNetAmout) }}
                </p>
              </div>
              <!--Added by Yogesh@2019-09-10 | @Description => To show the service tax -->
              <!-- <div class="d-flex justify-content-between">
                <p>Service Fees and Taxes :</p>
                <p v-if="this.$store.getters.SELECTED_SEATS.length > 0">
                  {{ curr_code }}
                  {{
                    currFormat(+parseFloat(totalAmountPrice - totalNetAmout))
                  }}
                </p>
              </div> -->
              <div
                class=""
                v-if="chargeTypeArray && chargeTypeArray.length > 0"
              >
                <div
                  class="d-flex justify-content-between"
                  v-for="(charge, chargeIndex) in [...chargeTypeArray].reverse()"
                  :key="chargeIndex"
                >
                  <p>{{ charge.ct_name }} :</p>
                  <p>
                    {{ curr_code }}
                    {{ currFormat(charge.tax_amount) }}
                  </p>
                </div>
              </div>
              <!--Added by Yogesh@2019-09-10 | @Description => To show the service tax-->

              <hr class="bottomLine my-4" />
            </div>

            <div
              class="d-flex justify-content-between"
              :class="{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }"
            >
              <div>
                <p class="mb-0 vCont">
                  Total Amount Payable :
                  <!-- <router-link class="hCont" to="#">(Change)</router-link> -->
                </p>
                <small class="vCont"
                  >(Amount inclusive of all service fees and taxes)</small
                >
              </div>
              <p class="hCont">
                {{ curr_code }} {{ currFormat(totalAmountPrice) }}
              </p>
            </div>
          </div>

          <!-- PROMO CODE -->
          <!-- <div class="promoCode-box" :class="{ hide : !showProceedToPayment }">
                  <p class="vCont">Apply Promo Code:
                    <router-link to="#" class="float-right pt-1 vCont">(View All Offers)
                    </router-link>
                  </p>
                  <b-input-group>
                    <b-form-input :disabled="!showProceedToPayment" v-model="promocode" type="text"
                      placeholder="Apply your promo code here" />
                    <b-input-group-append>
                      <b-button variant="default" @click="onApplyPromocode()" class="promo-btn">Apply Code</b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="mt-2 text-danger">{{this.promocodeErrorMessage}}</small>
                  <small class="mt-2 text-success">{{this.promocodeSuccesMessage}}</small>
                  </div>-->
        </div>
        <!-- TICKET END -->
        <!-- TABS START -->
        <div class="col-md-12 col-lg-9 px-0 px-lg-3 mb-4 modalCus">
          <div role="tablist" id="scrollToSection">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <b-button
                    block
                    href="#"
                    variant="transparent"
                    :class="{ active: collapse1 == true }"
                    v-b-toggle.accordion1
                    class="py-md-3 pr-5"
                  >
                    1. Please Choose A Preferred Cinema
                    <img
                      v-if="
                        Object.values(selectedCinemaObject).length > 0 &&
                          showTick1
                      "
                      src="@/assets/img/svg/tick-mark.svg"
                      class="img-fluid ml-2"
                    />
                    <span v-if="!collapse1" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-else-if="collapse1" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
              </b-card-header>
              <b-collapse
                id="accordion1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div
                    class="col-12 col-md-10 col-lg-8 col-xl-6 mb-md-4 mb-3 py-2 px-0 grp-drop"
                  >
                    <b-input-group>
                      <b-button variant="default" class="pr-1">
                        <img
                          src="@/assets/img/icons/Shape.png"
                          height="19"
                          width="19"
                        />
                      </b-button>
                      <b-form-input
                        @keyup.native="searchData()"
                        v-model="searchValue"
                        placeholder="Search for cinema"
                        class="pl-1"
                      />
                      <!-- <b-dropdown class="d-none d-md-block" text="Clementi (Singapore)" variant="default" slot="append">
                                    <b-dropdown-item>Clementi (Singapore)</b-dropdown-item>
                                    <b-dropdown-item>Clementi (Singapore)</b-dropdown-item>
                                    </b-dropdown>
                                    <b-dropdown class="d-block d-md-none" text="" variant="default" slot="append">
                                    <b-dropdown-item>Clementi (Singapore)</b-dropdown-item>
                                    <b-dropdown-item>Clementi (Singapore)</b-dropdown-item>
                                    </b-dropdown>-->
                    </b-input-group>
                  </div>
                  <div class="col-12" v-if="loadingContent == false">
                    <!-- ************************************************** -->

                    <!-- ************************************************** -->
                    <ul
                      class="movie-listing-mobile mt-2"
                      v-if="loadingContent == false && CinemaList.length > 0"
                    >
                      <!-- {{CinemaList}} -->
                      <li
                        v-for="(listing, listingKey) in CinemaList"
                        :key="listingKey"
                        v-on:click="onSelectCinema(listing)"
                        :class="{ active: selectedCinemaObject === listing }"
                      >
                        <div class="row">
                          <!-- <div class="organisation-name"> -->
                          <div class="col-8 col-md-9 organisation-name">
                            <!-- {{ listing.OrganizationName }} -->
                            {{ listing.cinema_name }}
                          </div>
                          <!-- <span class="text-danger" style="float:right">&nbsp; $1200</span> -->
                          <div
                            class="col-4 col-md-3 organisation-name align-self-end"
                          >
                            <span class="font-small d-block "
                              >Starting From</span
                            >
                          </div>
                          <!-- </div> -->
                          <div class="col-8 col-md-9">
                            <div class="organisation-address">
                              {{ listing.cinema_address }}
                              {{
                                listing.cinema_location
                                  ? `, ${listing.cinema_location}`
                                  : listing.cinema_location
                              }}
                            </div>
                            <ul
                              class="organisation-features"
                              v-if="listing.mf_name.length > 0"
                            >
                              <li v-for="(item, index) in listing.mf_name">
                                {{ item }}
                              </li>
                            </ul>
                            <!-- <div class="membership-promo">Membership promotion here</div> -->
                            <!-- <ul class="orginistion-recent-scheduling">
                                             <li class="pl-0">Recent Shows</li>
                                             <li>20:20</li>
                                             <li>21:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             </ul>-->
                          </div>
                          <div class="col-4 col-md-3">
                            <div class="organisation-name">
                              <span class="price">
                                {{ curr_code }}
                                {{
                                  String(listing.starting_price).split(".")[0]
                                }}.{{
                                  String(listing.starting_price).split(".")[1]
                                    .length == 1
                                    ? String(listing.starting_price).split(
                                        "."
                                      )[1] + "0"
                                    : String(listing.starting_price).split(
                                        "."
                                      )[1]
                                }}
                              </span>
                            </div>
                            <div
                              class="organisation-distance text-left"
                              v-if="false"
                            >
                              {{ listing.Distance }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div
                      class="my-4"
                      v-else-if="
                        CinemaList.length == 0 && loadingContent == false
                      "
                    >
                      <h5 class="text-center">No Cinema Found</h5>
                    </div>
                  </div>
                  <div class="row container-fluid" v-else-if="loadingContent">
                    <div class="col-12 text-center">
                      <img src="@/assets/img/loadMore.gif" class="load-more" />
                    </div>
                  </div>

                  <div
                    v-if="Object.entries(selectedCinemaObject).length > 0"
                    class="d-md-block proceed-btn"
                  >
                    <button
                      type="button"
                      name
                      v-on:click="fetchShowDates()"
                      id="CinemaLink"
                      class="btn py-md-2 px-md-5"
                    >
                      Proceed
                    </button>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1" id="showDateTime">
              <b-card-header
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <b-button
                    block
                    href="#"
                    variant="transparent"
                    v-b-toggle.accordion2
                    :class="
                      collapse2
                        ? 'active'
                        : Object.values(selectedCinemaObject).length > 0
                        ? ''
                        : 'disabled'
                    "
                    class="py-md-3"
                  >
                    2. Choose Date &amp; Time
                    <img
                      v-if="selectedTime.length > 0 && showTick2"
                      src="@/assets/img/svg/tick-mark.svg"
                      class="img-fluid ml-2"
                    />
                    <span v-if="!collapse2" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-else class="check-markIcon">
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
              </b-card-header>
              <b-collapse
                id="accordion2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div class="p-2">
                    <div class="row">
                      <div class="col-md-5 col-xl-5">
                        <!-- <date-pick :inputAttributes="{readonly: true}" v-model="date"></date-pick> -->
                        <div class="p-1 mb-4 p-xl-3 m-xl-1 calendar-box">
                          <calendar v-model="currentDate"></calendar>
                        </div>
                      </div>
                      <div
                        v-if="ShowTimes.length > 0 && UniqueKey == false"
                        class="col-md-7 col-xl-7"
                      >
                        <div
                          v-for="(singleShowTime, showtimeIndex) in ShowTimes"
                          :key="showtimeIndex"
                          class="movie-timing mb-4"
                        >
                          <div class="">
                            <span
                              >{{ singleShowTime.version_name.split("(")[0] }} -
                              ({{ singleShowTime.screen_name }})</span
                            >
                          </div>
                          <hr />
                          <div
                            class="timing-box"
                            v-if="singleShowTime.schedule_list.length > 0"
                          >
                            <ul class="timing-box-list">
                              <li
                                v-on:click="
                                  setCinemaTimeId(
                                    mTime,
                                    singleShowTime.version_name.split('(')[0]
                                  )
                                "
                                v-for="(mTime,
                                mT) in singleShowTime.schedule_list"
                                :key="mT"
                                :class="{
                                  active: CinemaTimeScheduleID == mTime
                                }"
                              >
                                {{ timeFormat(mTime.showTime) }}
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div
                          v-if="selectedTime"
                          class="proceed-btn ml-md-5 mt-md-3"
                        >
                          <button
                            type="button"
                            v-on:click="fetchShowTypes()"
                            name
                            v-b-toggle.accordion3
                            id
                            class="ml-md-4 btn py-md-2 px-md-5"
                          >
                            Proceed
                          </button>
                        </div>
                      </div>

                      <div v-if="ShowTimes.length == 0" class="col-md-7">
                        No Show Times
                      </div>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1" id="showScreening">
              <b-card-header
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <b-button
                    block
                    href="#"
                    variant="transparent"
                    v-b-toggle.accordion3
                    :class="
                      collapse3 == true
                        ? 'active'
                        : Object.values(ShowTypes).length > 0
                        ? ''
                        : 'disabled'
                    "
                    class="py-md-3"
                  >
                    3. Choose Screening Type
                    <img
                      v-if="ScreeningType.length > 0 && showTick3"
                      src="@/assets/img/svg/tick-mark.svg"
                      class="img-fluid ml-2"
                    />
                    <span v-if="!collapse3" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-else-if="collapse3" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
              </b-card-header>
              <b-collapse
                id="accordion3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <!-- {{ ShowTypes.length + "harshal" }} -->
                  <div
                    class="row screen-type"
                    v-if="Object.values(ShowTypes).length > 0"
                  >
                    <!-- CS-SCREENING  -->
                    <div
                      v-if="
                        singleShow.booking_type_id == '2' 
                      "
                      v-for="(singleShow, showIndex) in ShowTypes"
                      :key="showIndex"
                      class="col-md-4 align-items-end mb-3 mb-md-0 order-2 order-md-1"
                    >
                      <div class="d-none overflow-hidden d-md-block">
                        <div
                          class="p-2 cs-screening h-100 text-center d-flex flex-column justify-content-between py-2 py-md-3 py-lg-5"
                        >
                          <span class="tr-circle"></span>
                          <span class="tl-circle"></span>
                          <div>
                            <img
                              src="@/assets/img/svg/crowdsourced-screening-icon.svg"
                              class="img-fluid mb-2"
                            />
                            <p class="st-title">
                              {{ singleShow.screening_name }}
                            </p>
                            <p>{{ screeningMessage(singleShow) }}</p>
                            <!-- <router-link to="" class="i-btn"><img src="@/assets/img/svg/info-icon.svg"
                                             class="img-fluid"></router-link>-->
                          </div>
                          <div class="mt-2">
                            <button
                              type="button"
                              name
                              v-b-toggle.accordion4
                              id="Crowd"
                              v-on:click="getSeatLayout(singleShow)"
                              class="btn py-md-2 px-lg-4 px-xl-5  bg-info text-white"
                            >
                              Book Now
                            </button>
                          </div>
                          <span class="bl-circle"></span>
                          <span class="br-circle"></span>
                        </div>
                      </div>
                      <!-- CROWDSOURCED SCREENING MOBILE -->
                      <div class="d-block d-md-none">
                        <div class="p-2 cs-screening st-mobile">
                          <span class="tr-circle"></span>
                          <span class="tl-circle"></span>
                          <div
                            class="d-flex d-flex justify-content-between align-items-center mt-3"
                          >
                            <div>
                              <p class="st-title float-left ml-2 mt-2">
                                {{ singleShow.screening_name }}
                                <!-- <img class="ml-1" src="@/assets/img/icon-info-mob.png" width="18"> -->
                              </p>
                            </div>
                            <div>
                              <img
                                src="@/assets/img/svg/st-crowdsourced-mobile.svg"
                                height="40"
                              />
                            </div>
                          </div>
                          <p class="px-2 mt-2 st-txt">
                            {{ screeningMessage(singleShow) }}
                          </p>
                          <div
                            class="d-flex justify-content-between align-items-center mt-2"
                          >
                            <div></div>
                            <div>
                              <button
                                type="button"
                                name
                                v-b-toggle.accordion4
                                id="Crowd"
                                v-on:click="getSeatLayout(singleShow)"
                                class="btn py-md-2  px-lg-4 px-xl-5  btn-white"
                              >
                                Book Now
                              </button>
                            </div>
                          </div>
                          <span class="bl-circle"></span>
                          <span class="br-circle"></span>
                        </div>
                      </div>
                      <!-- MOBILE ENDS -->
                    </div>
                    <!-- CS-SCREENING END -->
                    <!-- CONFIRMING SCREENING TICKEt -->
                    <div
                      v-if="
                        singleShow.booking_type_id == '1' &&
                          singleShow.isAvailable
                      "
                      v-for="(singleShow, showIndex) in ShowTypes"
                      :key="showIndex"
                      class="col-md-4 mb-3 order-3 order-md-2"
                    >
                      <div class="d-none overflow-hidden d-md-block">
                        <div
                          class="p-2 confirm-screening h-100 text-center d-flex flex-column justify-content-between py-2 py-md-3 py-lg-5"
                        >
                          <span class="tr-circle"></span>
                          <span class="tl-circle"></span>
                          <div>
                            <img
                              src="@/assets/img/svg/confirm-screening-icon.svg"
                              class="img-fluid mb-2"
                            />
                            <p class="st-title">
                              {{ singleShow.screening_name }}
                            </p>
                            <p>{{ screeningMessage(singleShow) }}</p>
                            <!-- <router-link to="" class="i-btn"><img src="@/assets/img/svg/info-icon.svg"
                                             class="img-fluid"></router-link>-->
                          </div>
                          <div class="mt-2">
                            <button
                              type="button"
                              name
                              v-b-toggle.accordion4
                              id="Confirmed"
                              v-on:click="getSeatLayout(singleShow)"
                              class="btn bg-success py-md-2 px-lg-4 px-xl-5 text-white"
                            >
                              Book Now
                            </button>
                          </div>
                          <span class="bl-circle"></span>
                          <span class="br-circle"></span>
                        </div>
                      </div>
                      <!-- CONFIRMED SCREENING MOBILE -->
                      <div class="d-block d-md-none Confirmed Screening">
                        <div class="p-2 confirm-screening st-mobile">
                          <span class="tr-circle"></span>
                          <span class="tl-circle"></span>
                          <div
                            class="d-flex d-flex justify-content-between align-items-center mt-3"
                          >
                            <div>
                              <p class="st-title float-left ml-2 mt-2">
                                {{ singleShow.screening_name }}
                                <!-- <img class="ml-1" src="@/assets/img/icon-info-mob.png" width="18"> -->
                              </p>
                            </div>
                            <div>
                              <img
                                src="@/assets/img/svg/st-confirmed-mobile.svg"
                                height="40"
                              />
                            </div>
                          </div>
                          <p class="px-2 mt-3 st-txt">
                            {{ screeningMessage(singleShow) }}
                          </p>
                          <div
                            class="d-flex justify-content-between align-items-center mt-2"
                          >
                            <div></div>
                            <div>
                              <button
                                type="button"
                                name
                                v-b-toggle.accordion4
                                id="Confirmed"
                                v-on:click="getSeatLayout(singleShow)"
                                class="btn py-md-2  px-lg-4 px-xl-5   mt-3 btn-white"
                              >
                                Book Now
                              </button>
                            </div>
                          </div>
                          <span class="bl-circle"></span>
                          <span class="br-circle"></span>
                        </div>
                      </div>
                      <!-- MOBILE ENDS -->
                    </div>
                    <!-- CONFIRMING SCREENING TICKET ENDS -->
                    <!-- PRIVATE SCREENING TICKET -->
                    <div
                      v-if="
                        singleShow.booking_type_id == '3' &&
                          singleShow.isAvailable
                      "
                      v-for="(singleShow, showIndex) in ShowTypes"
                      :key="showIndex"
                      class="col-md-4 mb-3 order-1 order-md-3"
                    >
                      <div class="d-none overflow-hidden d-md-block">
                        <div
                          class="p-2 private-screening h-100 text-center d-flex flex-column justify-content-between py-2 py-md-3 py-lg-5"
                        >
                          <span class="tr-circle"></span>
                          <span class="tl-circle"></span>
                          <div>
                            <img
                              src="@/assets/img/svg/private-screening-icon.svg"
                              class="img-fluid mb-2"
                            />
                            <p class="st-title">
                              {{ singleShow.screening_name }}
                            </p>
                            <p>{{ screeningMessage(singleShow) }}.</p>
                            <p class="st-title">
                              {{ curr_code }}
                              {{ currFormat(singleShow.amount) }}
                            </p>
                            <p>
                              {{ singleShow.screen_total_seats }} Seats (Free
                              Seating)
                            </p>


                            <p>
                              {{ singleShow.cinema_desc }} 
                            </p>
                            <!-- <router-link to="" class="i-btn"><img src="@/assets/img/svg/info-icon.svg"
                                             class="img-fluid"></router-link>-->
                          </div>
                          <div class="mt-2 d-none d-md-block">
                            <button
                              type="button"
                              name
                              id="Private"
                              v-on:click="getSeatLayout(singleShow)"
                              class="btn py-md-2 px-lg-4 px-xl-5   bg-warning text-white"
                            >
                              Book Now
                            </button>
                          </div>
                          <span class="bl-circle"></span>
                          <span class="br-circle"></span>
                        </div>
                      </div>
                      <!-- PRIVATE SCREENING MOBILE -->
                      <div class="d-block d-md-none">
                        <div class="p-2 private-screening st-mobile">
                          <span class="tr-circle"></span>
                          <span class="tl-circle"></span>
                          <div
                            class="d-flex d-flex justify-content-between align-items-center mt-3"
                          >
                            <div>
                              <p class="st-title float-left ml-2 mt-2">
                                {{ singleShow.screening_name }}
                                <img
                                  class="ml-1"
                                  src="@/assets/img/svg/private-screening-icon.svg"
                                  width="18"
                                />
                              </p>
                            </div>
                            <div>
                              <img
                                src="@/assets/img/svg/st-private-mobile.svg"
                                height="40"
                              />
                            </div>
                          </div>
                          <p class="px-2 mt-2 mb-0 st-txt">
                            {{ screeningMessage(singleShow) }}
                          </p>
                          <div
                            class="d-flex align-items-center justify-content-between mt-2"
                          >
                            <div>
                              <!-- <p class="st-title px-2 mb-0">{{singleShow.CurrencyType}} {{singleShow.TotalSeatPrice}}</p> -->
                              <p class="px-2 st-txt">
                                {{ singleShow.screen_total_seats }} Seats (Free
                                Seating)
                              </p>
                            </div>
                            <div>
                              <button
                                type="button"
                                name
                                id="Private"
                                v-on:click="getSeatLayout(singleShow)"
                                class="btn py-md-2 px-lg-4 px-xl-5 btn-white"
                              >
                                Book Now
                              </button>
                            </div>
                          </div>
                          <span class="bl-circle"></span>
                          <span class="br-circle"></span>
                        </div>
                      </div>
                      <!-- PRIVATE SCREENING MOBILE END -->
                    </div>
                    <!-- PRIVATE SCREENING TICKET END -->
                  </div>
                  <div v-else-if="loadingShowType">
                    <div class="col-12 text-center">
                      <img src="@/assets/img/loadMore.gif" class="load-more" />
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="seat-selection mb-1" id="seatScreen">
              <b-card-header
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <b-button
                    block
                    href="#"
                    variant="transparent"
                    v-b-toggle.accordion4
                    :class="
                      collapse4 == true
                        ? 'active'
                        : ScreeningType.length > 0
                        ? ''
                        : 'disabled'
                    "
                    class="py-md-3"
                  >
                    4. Pick Seats
                    <img
                      v-if="showProceedToPayment"
                      src="@/assets/img/svg/tick-mark.svg"
                      class="img-fluid ml-2"
                    />
                    <span v-if="!collapse4" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-else-if="collapse4" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
              </b-card-header>
              <b-collapse
                id="accordion4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div class="col-12 mx-auto text-center px-0">
                    <div class="text-center">
                      <img
                        src="@/assets/img/svg/screen.svg"
                        class="img-fluid d-none d-md-block mx-auto"
                      />
                      <img
                        src="@/assets/img/svg/screen-mobile-new.svg"
                        class="mob-img-fluid d-md-none"
                      />
                    </div>

                    <div class="seat-count mt-0 mb-4 my-md-4">
                      <p
                        v-if="totalNumberOfSeats == 0"
                        class="text-center mt-3"
                      >
                        HOW MANY SEATS?
                      </p>
                      <p
                        v-if="
                          totalNumberOfSeats !== 0 && totalNumberOfSeats == 1
                        "
                        class="text-center mt-3"
                      >
                        Selected :
                        <span
                          >{{ this.$store.getters.SELECTED_SEATS.length }} /
                          {{ totalNumberOfSeats }} Seat</span
                        >&nbsp;&nbsp;
                        <span class="edit-class" v-on:click="onEdit()"
                          >(Edit)</span
                        >
                      </p>
                      <p
                        v-if="
                          totalNumberOfSeats !== 0 && totalNumberOfSeats != 1
                        "
                        class="text-center mt-3"
                      >
                        Selected :
                        <span v-if="createSchedulePayload.booking_type_id == 1"
                          >{{ this.$store.getters.SELECTED_SEATS.length }} seats
                          {{
                            this.createSchedulePayload["booking_type_id"] == 1
                              ? `(Minimum ${totalNumberOfSeats} Seats )`
                              : ""
                          }}</span
                        >
                        <span v-else
                          >{{ this.$store.getters.SELECTED_SEATS.length }} /
                          {{ totalNumberOfSeats }}
                          Seats </span
                        >&nbsp;&nbsp;
                        <span class="edit-class" v-on:click="onEdit()"
                          >(Edit)</span
                        >
                      </p>
                      <ul class="list-inline pick-seats mt-4">
                        <li
                          v-if="totalNumberOfSeats == 0"
                          v-for="(number, a) in 8"
                          :key="a"
                          class="list-inline-item"
                          v-on:click="editNumberOfSeats(number)"
                          :class="{ active: number == totalNumberOfSeats }"
                        >
                          {{ number }}
                        </li>
                      </ul>
                    </div>

                    <div class="seat-layout table-responsive">
                      <div
                        class="mx-auto text-center"
                        v-if="totalNumberOfSeats > 0 && seatType.length > 0"
                        v-for="(singleSeatLayout, seatIndex) in seatType"
                        :key="seatIndex"
                      >
                        <div
                          class="mt-4 mb-2 seat-formatTxt"
                          v-if="singleSeatLayout.seatsFinal.length > 0"
                        >
                          <div
                            class="seat-catg screen-class"
                            style="margin-top: 10px;"
                          >
                            <div>({{ singleSeatLayout.seatType }})</div>
                            <div>
                              Ticket Price : {{ curr_code }}
                              {{
                                currFormat(singleSeatLayout.seat_net_price) ||
                                  currFormat(singleSeatLayout.seat_price)
                              }}
                            </div>
                          </div>
                        </div>
                        <table class="mx-auto seat-table">
                          <!-- {{ seatTypes[seatTypeIndex].Label }} -->
                          <tr
                            v-for="(seatArray,
                            seatRowIndex) in singleSeatLayout.seatsFinal"
                            :key="seatRowIndex"
                          >
                            <td class="px-3 mt-2">
                              {{
                                seatArray.filter(x => x.sl_seat_name != "")
                                  .length > 0
                                  ? seatArray
                                      .filter(x => x.sl_seat_name != "")[0]
                                      .sl_seat_name.replace(/[0-9]/g, "")
                                  : ""
                              }}
                            </td>
                            <td
                              v-for="(singleSeat, singleSeatIndex) in seatArray"
                              :key="singleSeatIndex"
                            >
                              <div
                                v-if="singleSeat.srt_id == 2"
                                class="hide py-2"
                              ></div>
                              <div
                                v-else
                                v-on:click="
                                  $event => {
                                    if (checkSelectedSeats(singleSeat)) {
                                      handlerSeatSelected(
                                        singleSeat,
                                        seatRowIndex,
                                        singleSeatIndex,
                                        null,
                                        null,
                                        $event,
                                        seatIndex
                                      );
                                      seatsSelectedRateGroup();
                                    }
                                  }
                                "
                                :class="
                                  singleSeat.selectStatus == true
                                    ? singleSeat.srt_id == 3
                                      ? 'wheel active'
                                      : 'seat active'
                                    : singleSeat.seat_reserve_type_id == 1
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 3
                                    ? 'wheel'
                                    : singleSeat.seat_reserve_type_id == 6
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 7
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 8
                                    ? singleSeat.srt_id == 3
                                      ? 'wheel disabled seat'
                                      : 'seat disabled'
                                    : singleSeat.seat_reserve_type_id == 9
                                    ? 'seat disabled'
                                    : singleSeat.seat_reserve_type_id == 10
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 11
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 12
                                    ? 'seat disabled'
                                    : singleSeat.seat_reserve_type_id == 13
                                    ? 'seat disabled'
                                    : 'seat'
                                "
                              ></div>
                            </td>
                            <td class="px-3 mt-2">
                              {{
                                seatArray.filter(x => x.sl_seat_name != "")
                                  .length > 0
                                  ? seatArray
                                      .filter(x => x.sl_seat_name != "")[0]
                                      .sl_seat_name.replace(/[0-9]/g, "")
                                  : ""
                              }}
                            </td>
                            <!-- <td v-for="(seat, singleSeatIndex) in seatArray" :key="singleSeatIndex"
                               v-if="seat.Status == 2">
                              <div class="seat disabled"></div>
                            </td>-->
                          </tr>
                        </table>
                      </div>
                    </div>
                    <ul class="list-inline seat-info my-4 my-md-5">
                      <li class="list-inline-item">
                        <img
                          src="@/assets/img/svg/empty-seat.svg"
                          class="pb-1 mr-2"
                        />Available
                      </li>
                      <li class="list-inline-item">
                        <img
                          src="@/assets/img/svg/disable-seat.svg"
                          class="pb-1 mr-2"
                        />Unavailable
                      </li>
                      <li class="list-inline-item">
                        <img
                          src="@/assets/img/WhAv1.png"
                          style="width: 17px;"
                          class="pb-1 mr-2"
                        />Wheelchair
                      </li>
                    </ul>

                    <!-- :to="{ name: 'payment', params: { categoryId: CategoryID, scheduleId: CinemaTimeScheduleID }}" -->
                    <div class="text-danger my-2"></div>

                    <router-link to v-on:click.native="setBookingSeats()">
                      <div
                        v-if="
                          this.$store.getters.SELECTED_SEATS.length > 0 &&
                            this.$store.getters.SELECTED_SEATS.length >=
                              totalNumberOfSeats
                        "
                        class="proceed-btn"
                      >
                        <button
                          type="button"
                          name
                          id
                          class="btn btn-danger py-md-2 px-md-4 my-3"
                        >
                          Confirm
                        </button>
                      </div>
                    </router-link>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <div
            v-if="showProceedToPayment"
            class="col-12 col-md-9 col-xl-6 text-center mx-auto mt-5"
          >
            <div class="d-flex flex-column justify-content-between">
              <div class="mb-4">
                <img src="@/assets/img/svg/icons-movie.svg" claas="img-fluid" />
                <p class="at-text pt-3">
                  Almost there! Just one last thing before
                  <br />your screening is created!
                </p>
              </div>
              <div class="d-md-block proceed-btn">
                <div class="text-danger my-2">{{ showMessage }}</div>
                <router-link v-on:click.native="setBookingSeats()" to>
                  <button type="button" name id class="btn py-md-2 px-md-5">
                    Proceed to Payment
                  </button>
                </router-link>
              </div>
              <div>
                <img src="@/assets/img/svg/bg-gogo.svg" class="img-fluid" />
              </div>
            </div>
          </div>
          <b-modal
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-footer
            ref="SeatRealeased"
            class="text-center"
            id="minimumPayment"
            title="FAILED !"
          >
            <div class="p-5">
              <div class="text-center mt-3 mt-md-0">{{ showMessage }}</div>
              <b-button
                v-on:click="hideModal"
                class="w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
                >Go Back</b-button
              >
            </div>
          </b-modal>
          <!-- for wheel chair-->
          <div class="verify-c">
            <b-modal
              hide-footer
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              ref="WheelChairModal"
              class="text-center"
              id="WheelChairModal"
              title="Wheel Chair"
            >
              <div class="p-5">
                <div class="text-center mb-3">
                  <img
                    width="47"
                    height="auto"
                    src="@/assets/img/WheelSel.png"
                  />
                </div>
                <div class="text-center mt-3 mt-md-0 font-weight-bold">
                  Notice
                </div>
                <div class="text-center mt-3 mt-md-0">
                  You have selected a wheelchair space which is for wheelchair
                  user only.
                </div>
                <b-button
                  v-on:click="onClickOk()"
                  class="w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
                  >OK</b-button
                >
              </div>
            </b-modal>
            <b-modal
              hide-footer
              hide-header
              id="showRateCard"
              ref="showRateCard"
              title="Show Rate Card"
              class=""
              size="lg"
            >
              <div class="container px-2 px-md-3">
                <div class="select-seat-container-myticket">
                  <div
                    class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto"
                  >
                    <div class="row">
                      <div class="col-12 py-3 bg-light rounded">
                        <div class="row">
                          <div class="col-4">
                            <strong>TICKET </strong>
                          </div>
                          <div class="col-3">
                            <strong> PRICE </strong>
                          </div>
                          <div class="col-5">
                            <strong>No of Seats </strong>
                          </div>
                        </div>
                      </div>

                      <div
                        v-for="(item, index) in seatsSelectedRateGroupNew"
                        :key="index"
                        class="col-12 py-2 border-bottom"
                        v-if="seatsSelectedRateGroupNew"
                      >
                        <div class="st-name">{{ item.srt_name }}</div>
                        <div class="row align-self-center">
                          <!-- <div class="col-3 align-self-center">
                    <strong
                      >{{ item.srt_name }} ({{ item.totalSelected }}/{{
                        item.AllSeats.length
                      }})</strong
                    >
                  </div>
                  <div class="col-3 align-self-center">
                    <strong></strong>
                  </div> -->
                          <div
                            v-for="(rg, rg_index) in item.rate_card_group"
                            class="col-12 row my-2 p-0"
                          >
                            <div
                              class="col-4 align-self-center"
                              style="line-break: anywhere"
                            >
                              <strong>
                                {{ rg.tt_name }}
                              </strong>
                            </div>
                            <div class="col-3 align-self-center">
                              <strong>
                                {{ curr_code }}
                                {{ currFormat(rg.rc_total_amount) }}
                              </strong>
                            </div>
                            <div class="col-5">
                              <div
                                class="d-flex align-items-center justify-content-center w-100 h-100"
                              >
                                <button
                                  @click="
                                    totalCount(rg, index, rg_index, 'decrement')
                                  "
                                  class="cursor-pointer btn-subtract-myticket"
                                  :class="
                                    rg.totalSeatSelected == 0 ? 'disabled' : ''
                                  "
                                >
                                  -
                                </button>
                                <strong class="w-100px">{{
                                  rg.totalSeatSelected
                                }}</strong>
                                <button
                                  @click="
                                    totalCount(rg, index, rg_index, 'increment')
                                  "
                                  class="cursor-pointer btn-add-myticket"
                                  :class="
                                    item.totalSelected == item.AllSeats.length
                                      ? 'disabled'
                                      : ''
                                  "
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- TOTAL FOOTER -->

                          <!-- TOTAL FOOTER -->
                          <div class="col-12 py-3 bg-light rounded ">
                            <div class="row">
                              <div class="col-4">
                                <strong>Total Seat Selected</strong>
                              </div>
                              <div class="col-4">
                                <strong>
                                  <!-- {{ totalSeatBooked }}/{{ this.$store.getters.SELECTED_SEATS.length }} -->
                                </strong>
                              </div>
                              <div class="col-4">
                                <strong
                                  >{{ item.totalSelected }}/{{
                                    item.AllSeats.length
                                  }}</strong
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-12 py-3 my-2 bg-light rounded ">
                            <div class="row">
                              <div class="col-4">
                                <strong>Total Amount</strong>
                              </div>
                              <div class="col-4">
                                <strong>
                                  <!-- {{ totalSeatBooked }}/{{ this.$store.getters.SELECTED_SEATS.length }} -->
                                </strong>
                              </div>
                              <div class="col-4">
                                <strong
                                  >{{ curr_code }}
                                  {{ currFormat(totalAmountPrice) }}</strong
                                >
                              </div>
                            </div>
                          </div>
                          <!-- PROCEED BUTTON -->
                          <div class="col-12 py-4">
                            <!-- <h6 class="error" v-if="errorMessage">{{errorMessage}} </h6> -->
                            <!-- ADD ACTIVE CLASS WHEN ONE TICKET IS SELECTED  -->

                            <button
                              :disabled="errorMessage ? true : false"
                              class="btn btn-danger py-2 px-5 mt-3"
                              @click="onSubmitFromRateCardModal"
                            >
                              Proceed
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import { mapState, mapGetters, mapActions } from "vuex";
import Slick from "vue-slick";
import $ from "jquery";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import _ from "lodash";
import calendar from "@/components/partials/calendar.vue";
// import { dragscroll } from 'vue-dragscroll'
import { EventBus } from "@/main";
import MainServices from "@/services/mainService.js";
import cloneDeep from "lodash/cloneDeep";
var VueScrollTo = require("vue-scrollto");
import moment from "moment";

export default {
  name: "MyComponent",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {
    Slick,
    DatePick,
    calendar
  },

  data() {
    return {
      count: 0,
      showTick1: false,
      showTick2: false,
      showTick3: false,
      showProceedToPayment: false,
      promoApplied: false,
      currentDate: new Date(),
      sSlider: {
        dots: false,
        arrows: true,
        slidesToShow: 3.5,
        infinite: false,
        slidesToScroll: 3,
        centerPadding: "50px",
        loop: false,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              arrows: true,
              dots: false,
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: true,
              dots: false,
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      },
      date: "2019-01-01",
      movieDetails: {},
      MovieID: "",
      UniqueKey: false,
      NewShowTimeArray: [],
      LangFormat: "",
      ScreenName: "",
      screen_id: "",
      Currency: "",
      CategoryID: "",
      CinemaScheduleID: "",
      CinemaList: [],
      CinemaListCopy: [],
      selectedCinemaObject: {},
      ShowDates: [],
      ShowTimes: [],
      ShowTimesV1: {},
      ShowTypes: {},
      CinemaTimeScheduleID: "",
      selectedTime: "",
      ScreeningType: "",
      showMessage: "",
      seatLayout: [],
      seatTypes: [],
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      selectedSeats: [],
      row: "",
      column: "",
      newSeatLayout: [],
      NewShowTimeArray1: [],
      totalAmount: "",
      checkSize: "",
      ticketPrice: "",
      ServiceFee: "", // Added by Yogesh@2019-09-10 | @Description => To show the service tax
      searchValue: "",
      promocode: "",
      DiscountValue: "",
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      showDetails: {
        day: "",
        month: "",
        date: "",
        year: ""
      },
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      collapse1: true,
      collapse2: false,
      collapse3: false,
      collapse4: false,
      filterListCinema: [],
      CityArray: [],
      loadingContent: true,
      loadingShowType: false,
      loaderSeatLayout: false,
      priceTypeArray: [],
      remainingTicket: 0,
      TotalPriceNew: 0,
      showModalPrice: false,
      TaxRate: 0,
      TaxAmount: 0,
      ServiceFeePer: 0,
      ServiceFeeNew: 0,
      TaxAmountNew: 0.9,
      content_lang_id: 0,
      ScheduleDetailAll: [],
      cinema_id: null,
      fromDate: null,
      createSchedulePayload: {
        mrrdr_runtime: 0,
        start_time: "",
        schedule_date: "",
        cinema_ss_id: 0,
        guest_user_id: ""
      },

      //
      seatsSelectedRateGroupNew: [],
      totalAmountPrice: 0,
      totalSeatBooked: 0,
      totalNetAmout: 0,
      checkPopupExist: false,
      errorMessage: "",
      CinemaID: "",
      cinema_id: ""
    };
  },
  beforeMount() {
    this.MovieID = this.$route.params.movieId;
    this.CategoryID = this.$route.params.categoryId;
    this.CinemaID = this.$route.params.cinemaId;
    this.cinema_id = this.$route.params.cinemaId;
    this.content_lang_id = this.$route.params.content_lang_id;
    this.onResetSeatLayout();
  },

  async mounted() {
    //  console.log(screen.width,"fsfds")
    //  if(screen.width>992){
    //    this.checkSize="2";

    //  }else{
    //     this.checkSize="1";
    //  }
    await this.fetchMovieDetails();
    await this.GetCreateShowDetails();
    //  await  this.fetchCinemasList();
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (collapseId === "accordion1" && isJustShown) {
        this.collapse1 = true;
        this.collapse2 = false;
        this.collapse3 = false;
        this.collapse4 = false;
      }
      if (collapseId === "accordion2" && isJustShown) {
        this.collapse1 = false;
        this.collapse2 = true;
        this.collapse3 = false;
        this.collapse4 = false;
      }
      if (collapseId === "accordion3" && isJustShown) {
        this.collapse1 = false;
        this.collapse2 = false;
        this.collapse3 = true;
        this.collapse4 = false;
      }
      if (collapseId === "accordion4" && isJustShown) {
        this.collapse1 = false;
        this.collapse2 = false;
        this.collapse3 = false;
        this.collapse4 = true;
      }
    });
    if (this.CinemaID == "" || this.CinemaID == null) {
      setTimeout(function() {
        VueScrollTo.scrollTo("#scrollToSection", "1000");
      }, 1000);
    }

    EventBus.$on("currentDate", currentDate => {
      let date = dateFns.format(currentDate, "YYYY-MM-DD");
      let parts = date.split("-"),
        year = parseInt(parts[0], 10),
        month = parseInt(parts[1], 10) - 1, // NB: month is zero-based!
        day = parseInt(parts[2], 10);
      let date1 = new Date(year, month, day);
      this.showDetails.day = this.days[date1.getDay()].substring(0, 3);
      this.showDetails.date = date1.getDate();
      this.showDetails.month = this.months[date1.getMonth()].substring(0, 3);
      this.showDetails.year = year;
      this.fromDate = date;
      this.selectedTime = "";
      this.GetCreateShowDetails();
    });
  },

  computed: {
    chargeTypeArray() {
      let selectedSeats = this.$store.getters.seatsSelected;
      let tempArr = [];
      let testObj = {};
      let finalArr = [];

      if (selectedSeats.length > 0) {
        selectedSeats.forEach(x => {
          if (x.hasOwnProperty("chargeTypeArray")) {
            x.chargeTypeArray.forEach(y => {
              tempArr.push(y);
            });
          }
        });
      }

      if (tempArr.length > 0) {
        tempArr.forEach(function(o) {
          if (!testObj[o.ct_id]) {
            testObj[o.ct_id] = {
              ct_id: o.ct_id,
              ct_name: o.ct_name,
              tax_amount: 0,
              quantity: o.quantity
            };
            finalArr.push(testObj[o.ct_id]);
          }
          testObj[o.ct_id].tax_amount += +o.tax_amount;
        });
      }
      console.log(
        "this.$store.getters.SELECTED_SEATS",
        this.$store.getters.SELECTED_SEATS
      );
      console.log("finalArr", finalArr);
      return finalArr;
    },
    pickSeats() {
      let tempArray = [];
      let selectedSeats = this.$store.getters.seatsSelected;
      if (selectedSeats && selectedSeats.length > 0) {
        selectedSeats.map(x => {
          tempArray.push(x.sl_seat_name);
        });
      }
      if (tempArray.length > 0) {
        return tempArray.join(", ");
      } else {
        return "";
      }
    },
    curr_code() {
      return this.$store.getters.getCurrCode;
    },
    ...mapGetters([
      "getNowShowingDates",
      "getMovieDetailsScheduleList",
      "seatType",
      "seatsSelected",
      "totalPrice",
      "totalGrossPrice",
      // "getselectedDate",
      "getMovieDetailsScheduleList",
      "getMovieDetailsObject",
      "schedule_details_obj",
      "getGlobalCurrency",
      "getMovieDates",
      "getMovieId",
      "getCurrentLangIsoCode",
      "totalNumberOfSeats"
    ]),
    formattedDate() {
      console.log("this.currentDate :", this.selectedMainDate);
      // let dateValue = dateFns.format(this.currentDate, "YYYY-MM-DD")
      // this.filterDate(dateValue)
      // return dateFns.format(this.currentDate, "MM/DD/YYYY");
      return this.selectedMainDate;
    },
    ShowProceed() {
      let count = 0;
      this.priceTypeArray.map(x => {
        x.PriceType.map(y => {
          count = count + y.Selected;
        });
      });
      if (this.selectedSeats.length == count) {
        this.remainingTicket = 0;
        return true;
      } else {
        this.remainingTicket = this.selectedSeats.length - count;
        return false;
      }
    }
  },

  methods: {
    screeningMessage(screening) {
      if (screening.booking_type_id == 1) {
        return `Purchase ${
          screening["min_seats"]
        } tickets or more to confirm your screening immediately.`;
      } else if (screening.booking_type_id == 2) {
        return `Purchase less than ${
          screening["min_seats"]
        } tickets and invite your friends to crowdsource. Once the screening is confirmed, we will notify you!`;
      } else if (screening.booking_type_id == 3) {
        return `Book an exclusive private screening for your friends and family.`;
      } else {
        return screening.message;
      }
    },
    checkMinimumSeats(seat) {
      let selectedSeats = this.$store.getters.seatsSelected;
      if (this.totalNumberOfSeats) {
        let tempCheck = selectedSeats.filter(x => x.sl_id == seat.sl_id);
        if (tempCheck && tempCheck.length > 0) {
          return true;
        } else if (
          parseInt(selectedSeats.length) == parseInt(this.totalNumberOfSeats)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkSelectedSeats(seat) {
      let selectedSeats = this.$store.getters.seatsSelected;
      if (
        this.totalNumberOfSeats &&
        this.createSchedulePayload["booking_type_id"] == 2
      ) {
        let tempCheck = selectedSeats.filter(x => x.sl_id == seat.sl_id);
        if (tempCheck && tempCheck.length > 0) {
          return true;
        } else if (
          parseInt(selectedSeats.length) == parseInt(this.totalNumberOfSeats)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    fetchCinemasList: function() {
      let payload = {
        cinema_id: this.$route.params.cinemaId,
        movie_id: this.$route.params.movieId
      };
      MainServices.GetCinemaList(payload)
        .then(response => {

          console.log(response, "res >>>>>>>>>>>>>>>>>>>>")

          const { error, data } = response;

          this.CinemaList = data.Records;
          this.CinemaListCopy = data.Records;
          this.loadingContent = false;
          this.loadingFirst = false;
          if (this.cinema_id) {
            this.onSelectCinema(this.CinemaList[0]);
            this.fetchShowDates();
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    ...mapActions([
      "getSeats",
      "getMovieDetailsSelectedFilter",
      "SelectNumberOfSeats",
      "seatHandler",
      "RESERVE_SEATS",
      "onResetSeatLayout",
      "getAdditionalCharges",
      // "getselectedDate",
      "onSetDefaultFilter",
      "getScheduleDetails",
      "setScheduleObj",
      "onGetAllMoviesSchedulesSeatPage",
      "onSetCompleteRateCard",
      "onSetCompleteNewTotalAmount",
      "getVouchersList",
      "fetchStripePublisherKey",
      "getAllShowDates",
      "onGetMovieShowDates",
      "onGetMovieDetails"
    ]),
    totalCount(rg, index, rg_index, type) {
      console.log("selected seats", this.$store.getters.SELECTED_SEATS);
      let seatsSelectedRateGroupCopy = cloneDeep(
        this.seatsSelectedRateGroupNew
      );
      let x = seatsSelectedRateGroupCopy[index]["rate_card_group"][rg_index];
      if (
        type == "increment" &&
        seatsSelectedRateGroupCopy[index].totalSelected ==
          seatsSelectedRateGroupCopy[index].AllSeats.length
      ) {
        return false;
      }

      if (
        type == "increment" &&
        this.totalSeatBooked + 1 <= this.$store.getters.SELECTED_SEATS.length &&
        x["totalSeatSelected"] <= this.$store.getters.SELECTED_SEATS.length
      ) {
        console.log("line 743");
        x["totalSeatSelected"] = x["totalSeatSelected"] + 1;
        seatsSelectedRateGroupCopy[index].totalSelected =
          seatsSelectedRateGroupCopy[index].totalSelected + 1;
      } else if (
        seatsSelectedRateGroupCopy[index].totalSelected >= 1 &&
        type == "decrement" &&
        x["totalSeatSelected"] >= 1
      ) {
        console.log("line 752");
        x["totalSeatSelected"] = x["totalSeatSelected"] - 1;
        seatsSelectedRateGroupCopy[index].totalSelected =
          seatsSelectedRateGroupCopy[index].totalSelected - 1;
      }

      let totalAmount = 0;
      let totalSeatBooked2 = 0;
      let totalNetAmout2 = 0;
      seatsSelectedRateGroupCopy.map(z => {
        z.rate_card_group.map(y => {
          totalAmount =
            parseFloat(totalAmount) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_total_amount);

          totalNetAmout2 =
            parseFloat(totalNetAmout2) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_net_amount);
        });

        totalSeatBooked2 =
          parseInt(totalSeatBooked2) + parseInt(z.totalSelected);
      });
      this.totalAmountPrice = totalAmount;
      this.totalSeatBooked = totalSeatBooked2;
      this.totalNetAmout = totalNetAmout2;
      // x["tt_name"] = x["tt_name"] + " ";
      if (totalSeatBooked2 == this.$store.getters.SELECTED_SEATS.length) {
        console.log("line 779");
        // this.$store.dispatch("onSetCompleteRateCard", {
        //   status: true,
        //   seatGroup: this.seatsSelectedRateGroupNew,
        // });
        // this.$store.dispatch("onSetCompleteNewTotalAmount", {
        //   totalAmount: this.totalAmountPrice,
        //   netAmount: this.totalNetAmout,
        // });
      } else {
        console.log("line 789");
        this.$store.dispatch("onSetCompleteRateCard", {
          status: false,
          seatGroup: cloneDeep(seatsSelectedRateGroupCopy)
        });
      }
      this.seatsSelectedRateGroupNew = seatsSelectedRateGroupCopy;
      console.log(this.seatsSelectedRateGroupNew);
      console.log("fdsfdsfdsf");
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        this.errorMessage = "";
      } else {
        this.errorMessage = "Please Select All Seats";
      }
    },
    hidePriceModal() {
      this.$refs.gogoModal.hide();
    },
    IncrementSelected(item, index2, index1) {
      console.log(item);
      this.priceTypeArray[index1]["PriceType"][index2]["Selected"]++;
      this.priceTypeArray[index1]["NoOfSeatSelected"]++;
      this.ServiceFeeNew = parseFloat(
        +parseFloat(this.ServiceFeeNew) + parseFloat(item.ServiceFee)
      ).toFixed(2);
      this.TaxAmountNew = parseFloat(
        +parseFloat(this.TaxAmountNew) + parseFloat(item.TaxAmountPer)
      ).toFixed(2);
      this.ServiceFeePerNew = parseFloat(
        +parseFloat(this.ServiceFeePerNew) + parseFloat(item.ServiceFeePer)
      ).toFixed(2);

      this.ticketPriceNew = parseFloat(
        +parseFloat(this.ticketPriceNew) + parseFloat(item.Price)
      ).toFixed(2);
      this.TotalPriceNew = parseFloat(
        +parseFloat(this.ticketPriceNew) + parseFloat(this.ServiceFeeNew)
      ).toFixed(2);
    },
    DecrementSelected(item, index2, index1) {
      if (this.priceTypeArray[index1]["PriceType"][index2]["Selected"] > 0) {
        this.priceTypeArray[index1]["PriceType"][index2]["Selected"]--;
        this.priceTypeArray[index1]["NoOfSeatSelected"]--;
        this.ServiceFeeNew = parseFloat(
          parseFloat(this.ServiceFeeNew) - parseFloat(item.ServiceFee)
        ).toFixed(2);

        this.TaxAmountNew = parseFloat(
          parseFloat(this.TaxAmountNew) - parseFloat(item.TaxAmountPer)
        ).toFixed(2);
        this.ServiceFeePerNew = parseFloat(
          parseFloat(this.ServiceFeePerNew) - parseFloat(item.ServiceFeePer)
        ).toFixed(2);
        this.ticketPriceNew = parseFloat(
          parseFloat(this.ticketPriceNew) - parseFloat(item.Price)
        ).toFixed(2);
        this.TotalPriceNew = parseFloat(
          this.TotalPriceNew -
            parseFloat(item.Price) -
            parseFloat(item.ServiceFee)
        ).toFixed(2);
      }
    },
    filterListAll(org, index2, index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });

      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.closeFilter();

      this.fetchCinemasList();
    },
    showFilter(index) {
      if (this.checkSize != "" && this.filterListCinema[index]["Show"]) {
        this.filterListCinema[index]["Show"] = false;

        this.closeFilter();
        return false;
      }

      this.filterListCinema.map(x => {
        x["Show"] = false;
      });
      this.filterListCinema[index]["Show"] = true;
      if (screen.width > 992) {
        this.checkSize = "2";
      } else {
        this.checkSize = "1";
      }
      var element = document.getElementsByTagName("body")[0];

      element.classList.add("overflow-hidden");
    },
    closeFilter() {
      this.checkSize = "";
      var element = document.getElementsByTagName("body")[0];
      element.classList.remove("overflow-hidden");
      this.filterListCinema.map(x => {
        x["Show"] = false;
      });
      this.selectedCinemaObject = {};
    },
    clearAllState(index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });

      this.CityArray = [];
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    FilterAllState(index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    CityList(state, index2, index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });
      //  console.log( this.filterListCinema[index1]["list"][index2]["Show"],"sfdfsdfdsfdsf");
      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.CityArray = state.CityList;
    },
    DistrictList(city, index3, index1) {
      this.CityArray.map(x => {
        x["Show"] = false;
      });
      //  console.log( this.CityArray[index3]["Show"],"sfdfsdfdsfdsf");
      this.CityArray[index3]["Show"] = true;
      this.closeFilter();
      this.fetchCinemasList();
    },

    hideModal() {
      this.$refs.SeatRealeased.hide();
      this.collapse1 = true;
      this.collapse2 = false;
      this.collapse3 = false;
      this.collapse4 = false;
      this.$root.$emit("bv::toggle::collapse", "accordion1");
      this.onChangeCinema();
      this.GetCreateShowDetails();
      this.showTick1 = true;
      this.showTick2 = false;
      (this.showTick3 = false),
        this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
          if (collapseId === "accordion1" && isJustShown) {
            this.collapse1 = true;
            this.collapse2 = false;
            this.collapse3 = false;
            this.collapse4 = false;
          }
          if (collapseId === "accordion2" && isJustShown) {
            this.collapse1 = false;
            this.collapse2 = true;
            this.collapse3 = false;
            this.collapse4 = false;
          }
          if (collapseId === "accordion3" && isJustShown) {
            this.collapse1 = false;
            this.collapse2 = false;
            this.collapse3 = true;
            this.collapse4 = false;
          }
          if (collapseId === "accordion4" && isJustShown) {
            this.collapse1 = false;
            this.collapse2 = false;
            this.collapse3 = false;
            this.collapse4 = true;
          }
        });
      if (this.CinemaID == "" || this.CinemaID == null) {
        setTimeout(function() {
          VueScrollTo.scrollTo("#scrollToSection", "1000");
        }, 1000);
      }
      this.onResetSeatLayout();
      this.totalNumberOfSeats = 0;

      this.editNumberOfSeats(0);
      // if (this.ScreeningType != "Private Screening") {
      //   this.$root.$emit("bv::toggle::collapse", "accordion4");
      // }
    },
    onClickOk: function() {
      this.count = 0;
      this.$refs.WheelChairModal.hide();
    },

    //Change function
    onChangeCinema: function() {
      this.selectedCinemaObject = {};
      this.selectedTime = "";
      this.ShowTypes = {};
      this.ScreeningType = "";
      this.totalAmount = "";
      this.selectedSeats = [];
      this.CinemaTimeScheduleID = "";
      this.ScreenName = "";
      this.screen_id = "";
    },

    onChangeDateTime: function() {
      this.selectedTime = "";
      this.ShowTypes = {};
      this.ScreeningType = "";
      this.totalAmount = "";
      this.selectedSeats = [];
    },

    onChangeScreeningType: function() {
      this.ScreeningType = "";
      this.totalAmount = "";
      this.selectedSeats = [];
    },

    onApplyPromocode: function() {
      let payload = {
        CouponCode: this.promocode,
        Total: this.totalAmount
      };
      makeRequest("/Payment/VerifyCoupon/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.promocodeSuccesMessage = res.data.Message;
            this.promocodeErrorMessage = "";
            this.promoApplied = true;
            this.totalAmount = res.data.TicketValue;
            this.DiscountValue = res.data.DiscountValue;
          } else {
            this.promocodeErrorMessage = res.data.Message;
            this.promocodeSuccesMessage = "";
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    searchData: function() {
      this.selectedCinemaObject = {};
      this.CinemaList = this.CinemaListCopy;
      if (this.searchValue.length > 0) {
        this.CinemaList = this.CinemaList.filter(cinema => {
          let str = this.searchValue.toLowerCase();
          let cinemaName = cinema.cinema_name.toLowerCase();
          if (cinemaName.includes(str)) {
            return cinema;
          }
        });
      } else {
        this.CinemaList = this.CinemaListCopy;
      }
      // this.$refs.cinemaSlick.destroy();
      // this.$nextTick(() => {
      //   this.$refs.cinemaSlick.create();
      //   this.$refs.cinemaSlick.goTo(0, true);
      // });
    },
    onEdit: function() {
      // this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      //   console.log("collapseId:", collapseId);
      //   console.log("isJustShown:", isJustShown);
      //   if (collapseId == 4 && isJustShown) {

      //   }
      // });
      this.totalAmount = "";
      this.totalNumberOfSeats = 0;
      this.editNumberOfSeats(0);
    },
    fetchMovieDetails: function() {
      let payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1
      };
      MainServices.GetMovieDetails(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("responseMovie", response);
            this.movieDetails = data.Records[0];
            let trailer = data.Records[0].trailer_array.filter(x => {
              return x.lang_id == 1;
            });
            let directors = data.Records[0].castCrewDetails.filter(z => {
              return z.crew_title.includes("Director");
            });
            let Actors = data.Records[0].castCrewDetails.filter(z => {
              return z.crew_title.includes("Actor");
            });
            console.log(Actors, directors);
            this.movieDetails["Actors"] = [];
            this.movieDetails["Directors"] = [];
            this.movieDetails["mrrdr_release_date_year"] = moment(
              this.movieDetails.mrrdr_release_date
            ).format("YYYY");
            if (directors.length > 0) {
              this.movieDetails["Directors"] = directors[0]["Crew"];
            }
            if (Actors.length > 0) {
              this.movieDetails["Actors"] = Actors[0]["Crew"];
            }

            if (trailer.length > 0) {
              this.movieDetails.original_trailer = trailer[0].mt_link;
            }
            this.hideLoading();
          }
        })
        .catch(err => {
          console.log("error", err);
        });
    },
    GetCreateShowDetails: function() {
      this.showLoading();
      let payload = {
        movie_id: this.MovieID,
        guest_user_id: localStorage.getItem("guest_user_id"),
        category_id: 1,
        cinema_id: this.cinema_id ? this.cinema_id : null,
        fromDate: this.fromDate ? this.fromDate : null
      };
      MainServices.GetCreateShowDetails(payload)
        .then(response => {
          const { data } = response;
          if (!this.fromDate) {
            this.ScheduleDetailAll = data;
            this.fetchCinemasList();
          } else {
            let NewShowTIme =
              data.MovieListArray.length > 0
                ? data.MovieListArray[0].CinemaList.length > 0
                  ? data.MovieListArray[0].CinemaList[0].format_list
                  : []
                : [];
            this.ShowTimes = [];
            if (NewShowTIme.length > 0) {
              NewShowTIme.map(x => {
                x.screen_list.map(y => {
                  y["version_name"] = x.version_name;
                  this.ShowTimes.push(y);
                });
              });
            }
            console.log(this.ShowTimes, "fsddfdsf");
          }
          this.hideLoading();
        })
        .catch(err => {
          console.log("error", err);
        });
    },

    onSelectCinema(cinemaObject) {
      this.selectedCinemaObject = cinemaObject;
      this.cinema_id = cinemaObject.cinema_id;
      this.selectedTime = "";
    },
    fetchShowDates: function() {
      this.$root.$emit("bv::toggle::collapse", "accordion2");
      // this.showLoading();
      console.log(this.ScheduleDetailAll, "fsfsf");
      this.ShowDates = this.ScheduleDetailAll.dateList.filter(x => {
        return x.isDateAvailable == true;
      });

      this.date = this.ShowDates[0].dateShow;
      this.fromDate = this.ShowDates[0].dateShow;
      this.GetCreateShowDetails();
      EventBus.$emit("showDates", this.ShowDates);
      let parts = this.date.split("-"),
        year = parseInt(parts[0], 10),
        month = parseInt(parts[1], 10) - 1, // NB: month is zero-based!
        day = parseInt(parts[2], 10);
      let date1 = new Date(year, month, day);
      this.showDetails.day = this.days[date1.getDay()].substring(0, 3);
      this.showDetails.date = date1.getDate();
      this.showDetails.month = this.months[date1.getMonth()].substring(0, 3);
      this.showDetails.year = year;
      EventBus.$emit("showDate", this.date);

      // let payload = {
      //   MovieID: this.MovieID,
      //   CinemaID: this.selectedCinemaObject.CinemaID,
      //   CategoryID: this.CategoryID,
      //   Version: "1"
      // };

      // makeRequest("/GetShowDate/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Cinema.length > 0) {
      //       this.ShowDates = res.data.Cinema;
      //       this.date = this.ShowDates[0].SchTDate;

      //       EventBus.$emit("showDates", this.ShowDates);
      //       EventBus.$emit("showDate", this.date);
      //       this.showTick1 = true;
      //       this.fetchShowTimes(this.ShowDates[0].CinemaScheduleID);
      //       setTimeout(() => {
      //         VueScrollTo.scrollTo("#showDateTime");
      //       }, 500);
      //     } else {
      //       this.hideLoading();
      //       this.ShowTimes = [];
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    filterDate: function(date) {
      this.ShowDates.filter(dates => {
        if (dates.SchTDate === date) {
          this.fetchShowTimes(dates.CinemaScheduleID);
          this.selectedTime = "";
        } else {
          this.ShowTimes = [];
        }
      });
    },
    fetchShowTimes: function(CinemaScheduleID) {
      let payload = {
        CategoryID: this.CategoryID,
        CinemaID: this.selectedCinemaObject.CinemaID,
        CinemaScheduleID: CinemaScheduleID,
        MovieID: this.MovieID,
        Version: "1"
      };
      makeRequest("/GetShowTime/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.hideLoading();
          let _times = res.data.Cinema;

          if (res.data.hasOwnProperty("Version") && res.data.Version) {
            this.UniqueKey = res.data.Version;
            this.NewShowTimeArray = res.data.CinemaNewList;
            // for(show in this.NewShowTimeArray){
            this.NewShowTimeArray1 = [];
            // this.NewShowTimeArray1.push
            // }
            console.log(this.NewShowTimeArray);
            this.NewShowTimeArray.map(shows => {
              console.log("shows :", shows);
              shows.CinemaList.map(show => {
                show.Key = shows.Key;
                this.NewShowTimeArray1.push(show);
              });
            });
            console.log(this.NewShowTimeArray1);
          }
          this.NewShowTimeArray1 = this.NewShowTimeArray1.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            console.log(
              "b.ShowDate :",
              b.ShowDate,
              a.ShowDate,
              new Date(b.ShowDate) - new Date(a.ShowDate)
            );
            return new Date(a.ShowDate) - new Date(b.ShowDate);
          });

          _times = _times.map(x => {
            x.CinemaTimings = tConvert(x.CinemaTimings);
            return x;
          });
          this.ShowTimes = _times;
          // this.ShowTimes = res.data.Cinema;
          this.ShowTimesV1 = _times;
          console.log("ShowTimesV1 :", this.ShowTimesV1);
          this.ShowTimes = _.groupBy(this.ShowTimes, "Format");
        })
        .catch(error => {
          console.log("Error", error);
        });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    setCinemaTimeId(mTime, LangFormat) {
      console.log(LangFormat);
      this.selectedTime = mTime.showTime;
      this.CinemaTimeScheduleID = mTime;
      // this.LangFormat = LangFormat;
      this.LangFormat = LangFormat;
      this.ScreenName = mTime.screen_name;
      this.screen_id = mTime.screen_id;
      let obj = {
        mrrdr_runtime: mTime.lengthMinutes,
        start_time: mTime.showTime,
        schedule_date: this.fromDate,
        cinema_ss_id: mTime.cinema_ss_id,
        guest_user_id: localStorage.getItem("guest_user_id")
      };
      console.log(obj);
      this.createSchedulePayload = {
        ...obj
      };
      console.log(this.createSchedulePayload, obj);
    },
    fetchShowTypes() {
      this.loadingShowType = true;
      let payload = {
        ...this.createSchedulePayload
      };
      MainServices.ReserveShowsMyCinema(payload)
        .then(resNew => {
          console.log(resNew);
          if (resNew.data.status) {
            this.createSchedulePayload["mycinema_ss_d_id"] =
              resNew.data.mycinema_ss_d_id;
            let payloadNew = { mycinema_ss_d_id: resNew.data.mycinema_ss_d_id };
            MainServices.GetScreeningType(payloadNew)
              .then(resBookingType => {
                if (resBookingType.data.status) {
                  this.ShowTypes = resBookingType.data.Records;

                  // console.log(resBookingType.data.Records, "resBookingType.data.Records >>>>>>>>>>>>>>>")
                  // console.log(this.ShowTypes, "this.ShowTypes >>>>>>>>>>>>>>>")
                  this.showTick2 = true;
                  setTimeout(() => {
                    VueScrollTo.scrollTo("#showScreening");
                  }, 500);
                }

                this.loadingShowType = false;
              })
              .catch(err => {
                this.loadingShowType = false;
                this.showMessage = `Something Went Wrong`;
                this.$refs.SeatRealeased.show();
              });
          } else {
            this.loadingShowType = false;
            this.showMessage = resNew.data.message;
            this.$refs.SeatRealeased.show();
          }
        })
        .catch(err => {
          this.loadingShowType = false;
          this.showMessage = `Something Went Wrong`;
          this.$refs.SeatRealeased.show();
        });

      // makeRequest("/GetShowType/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.ShowTypes = res.data.ShowType;
      //     delete this.ShowTypes["Public_N"];
      //     this.showTick2 = true;
      //     setTimeout(() => {
      //       VueScrollTo.scrollTo("#showScreening");
      //     }, 500);
      //     this.loadingShowType = false;
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    async getSeatLayout(seatType) {
      console.log(seatType);
      this.onResetSeatLayout();
      this.loaderSeatLayout = true;
      this.totalNumberOfSeats = 0;
      this.selectedSeats = [];
      this.showTick3 = true;

      let ShowType = "";
      this.createSchedulePayload["booking_type_id"] = seatType.booking_type_id;
      if (seatType.booking_type_id == "3") {
        this.showLoading();
        let reservation_id = Math.floor(100000000 + Math.random() * 900000000);

        let payloadPrivate = {
          groupRateCard: true,
          seat_layout_id: [],
          schedule_show_id: 0,
          cinema_reservation_id: reservation_id,
          isVipOrBlockSeats: false,
          cinema_id: this.cinema_id,
          screen_id: this.screen_id,
          mycinema_ss_d_id: this.createSchedulePayload.mycinema_ss_d_id,
          mycinema_booking_type_id: 3,
          newSeatLayout: [],
          seat_type_id: [],
          specialRequest: ""
        };
        console.log(payloadPrivate);
        MainServices.ReserveSeatsCreateShow(payloadPrivate)
          .then(responsePrivate => {
            if (responsePrivate.data.status) {
              this.hideLoading();
              this.$router.push({
                path: `/payment/${reservation_id}/2`
              });
            } else {
              this.showMessage = responsePrivate.data.message;
              this.$refs.SeatRealeased.show();
              this.hideLoading();
            }
          })
          .catch(err => {
            this.showMessage = `Something Went Wrong`;
            this.$refs.SeatRealeased.show();
            this.hideLoading();
          });
      } else {
        setTimeout(() => {
          VueScrollTo.scrollTo("#seatScreen");
        }, 500);
        this.ScreeningType = seatType.screening_name;
        this.secureStore.set("SCRTN", this.ScreeningType);
        this.secureStore.set("SCRT", "Public");
        ShowType = "Public";
        this.loaderSeatLayout = false;
        this.totalNumberOfSeats =
          seatType.booking_type_id == "1" ? seatType.min_seats : 0;
        if (this.totalNumberOfSeats > 0) {
          this.editNumberOfSeats(this.totalNumberOfSeats);
        }
        console.log(
          "Waiting",
          this.createSchedulePayload["mycinema_ss_d_id"],
          this.totalNumberOfSeats
        );
        await this.getSeats({
          mycinema_ss_d_id: this.createSchedulePayload["mycinema_ss_d_id"]
        });
        console.log("get Seat Layout Occurs", this.seatType);

        if (this.seatType.length == 0) {
          this.showMessage = `Sorry, your show is already reserved.`;
          this.$refs.SeatRealeased.show();
        }
      }
    },
    getSeatLayoutOld(seatType) {
      this.loaderSeatLayout = true;
      this.totalNumberOfSeats = 0;
      this.selectedSeats = [];
      this.showTick3 = true;

      let ShowType = "";
      if (seatType.title == "Private Screening") {
        this.ScreeningType = seatType.title;
        this.secureStore.set("SCRTN", this.ScreeningType);
        this.secureStore.set("SCRT", "Private");
        ShowType = "Private";
        this.selectedSeats = new Array(100);
        this.Currency = seatType.CurrencyType;
        this.totalAmount = seatType.TotalSeatPrice;
        this.ticketPrice = seatType.Price;
        this.ServiceFee = seatType.ServiceFee;
        // this.showModalPrice=false;

        // this.totalAmount =
        this.setBookingSeats();
      } else if (seatType.title1 == "Crowdsourced Screening") {
        setTimeout(() => {
          VueScrollTo.scrollTo("#seatScreen");
        }, 500);
        this.ScreeningType = seatType.title1;
        this.secureStore.set("SCRTN", this.ScreeningType);
        this.secureStore.set("SCRT", "Public");
        ShowType = "Public";
        let payload = {
          CinemaScheduleID: this.CinemaTimeScheduleID,
          CategoryID: this.CategoryID,
          ShowType: ShowType
        };
        makeRequest("/GetSeatLayout/", "POST", null, payload)
          .then(response => {
            console.log(this.newSeatLayout);

            const { error, res } = response;
            this.priceTypeArray = res.data.SeatTypes;
            // this.seatLayout = res.data.SeatLayouts;
            this.seatTypes = res.data.SeatTypes;
            this.row = res.data.Row;
            this.column = res.data.Column;
            this.Currency = res.data.Currency;
            // this.newSeatLayout.push(_.chunk(this.seatLayout[0].Seats,this.column ))
            // this.newSeatLayout.push(_.chunk(this.seatLayout[1].Seats,this.column ))
            // this.newSeatLayout = this.seatLayout.map(singleLayout => {
            //   return _.chunk(singleLayout.Seats, this.column);
            // });
            // this.newSeatLayout.map(seatType => {
            //   seatType.map(seatRow => {
            //     seatRow.map(seat => {
            //       seat.SelectStatusFlag = false;
            //       seat.SelectStatus = false;
            //     });
            //   });
            // });
            ///////////////something
            let seatArray = res.data.SeatLayouts;
            if (seatArray[0].Seats) {
              seatArray.map(x => {
                x.Seats.map(y => {
                  y.SelectStatus = false;
                  y.SelectStatusFlag = false;
                  return y;
                });
                x.Seats = _.chunk(x.Seats, this.column);
                x.SeatClass = this.seatTypes;
                return x;
              });
            }
            this.seatLayout = seatArray;
            this.loaderSeatLayout = false;
          })
          .catch(error => {
            console.log("Error", error);
          });
      } else if (seatType.title1 == "Confirmed Screening") {
        setTimeout(() => {
          VueScrollTo.scrollTo("#seatScreen");
        }, 500);
        this.totalNumberOfSeats = seatType.MinSeats;
        this.ScreeningType = seatType.title1;
        console.log(ScreeningType, "ScreeningType >>>>>>>>>>>>>>>>>>")
        this.secureStore.set("SCRTN", this.ScreeningType);
        this.secureStore.set("SCRT", "Public");
        ShowType = "Public";
        let payload = {
          CinemaScheduleID: this.CinemaTimeScheduleID,
          CategoryID: this.CategoryID,
          ShowType: ShowType
        };
        makeRequest("/GetSeatLayout/", "POST", null, payload)
          .then(response => {
            console.log(this.newSeatLayout);
            const { error, res } = response;
            // this.seatLayout = res.data.SeatLayouts;

            this.priceTypeArray = res.data.SeatTypes;
            this.seatTypes = res.data.SeatTypes;
            this.row = res.data.Row;
            this.column = res.data.Column;
            this.Currency = res.data.Currency;
            // this.newSeatLayout.push(_.chunk(this.seatLayout[0].Seats,this.column ))
            // this.newSeatLayout.push(_.chunk(this.seatLayout[1].Seats,this.column ))
            // this.newSeatLayout = this.seatLayout.map(singleLayout => {
            //   return _.chunk(singleLayout.Seats, this.column);
            // });
            // this.newSeatLayout.map(seatType => {
            //   seatType.map(seatRow => {
            //     seatRow.map(seat => {
            //       seat.SelectStatusFlag = false;
            //       seat.SelectStatus = false;
            //     });
            //   });
            // });
            ///////////////something
            let seatArray = res.data.SeatLayouts;
            if (seatArray[0].Seats) {
              seatArray.map(x => {
                x.Seats.map(y => {
                  y.SelectStatus = false;
                  y.SelectStatusFlag = false;
                  return y;
                });
                x.Seats = _.chunk(x.Seats, this.column);
                x.SeatClass = this.seatTypes;
                return x;
              });
            }
            this.seatLayout = seatArray;
            this.loaderSeatLayout = false;
          })
          .catch(error => {
            console.log("Error", error);
          });
      }
    },
    editNumberOfSeats: function(number) {
      this.SelectNumberOfSeats(number);
      this.totalNumberOfSeats = number;
      //deselect all
      this.selectedSeats.map((x, index) => {
        this.seatLayout[x.mainIndex].Seats[x.rowIndex][
          x.seatIndex
        ].SelectStatus = false;
        this.seatLayout[x.mainIndex].Seats[x.rowIndex][
          x.seatIndex
        ].SelectStatusFlag = false;
      });
      this.selectedSeats = [];
    },
    handlerSeatSelected: async function(
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    ) {
      if (seat.seat_reserve_type_id == 9) {
        this.$toasted.show(
          $t("Sorry! These seats can be booked from Box Office only")
        );
        return;
      }

      let payload = {
        seat,
        rowIndex,
        seatIndex,
        originalIndex,
        backward,
        e,
        type
      };
      console.log("seat payload", payload);
      await this.seatHandler(payload);
      if (seat.srt_id == 3 && seat.selectStatus) {
        this.$refs.WheelChairModal.show();
      }
    },
    seatsSelectedRateGroup() {
      let array = [];
      if (this.checkPopupExist == false) {
        this.totalSeatBooked = 0;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        let checkCheckoutRateCardNeeded = 0;
        if (this.$store.getters.SELECTED_SEATS.length > 0) {
          this.$store.getters.SELECTED_SEATS.map(x => {
            let find_In = array.findIndex(new1 => {
              return new1.sst_id == x.sst_id;
            });
            if (find_In >= 0) {
              array[find_In]["AllSeats"].push(x);
              if (array[find_In]["rate_card_group"].length == 1) {
                array[find_In]["totalSelected"] =
                  array[find_In]["totalSelected"] + 1;
                array[find_In]["rate_card_group"][0].totalSeatSelected =
                  array[find_In]["rate_card_group"][0].totalSeatSelected + 1;
                // console.log(x.rc_total_amount, "test");
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(
                    array[find_In]["rate_card_group"][0].rc_total_amount
                  );
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(
                    array[find_In]["rate_card_group"][0].rc_net_amount
                  );
                this.totalSeatBooked = this.totalSeatBooked + 1;
              } else if (array[find_In]["rate_card_group"].length > 1) {
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
              }
            } else {
              let arrayCardGroup = [];
              x.rate_card_group.map(rg => {
                rg["totalSeatSelected"] = 0;
                arrayCardGroup.push(rg);
              });
              console.log(x, "Seats");
              let obj = {
                srt_name: x.sst_seat_type,
                sst_id: x.sst_id,
                AllSeats: [x],
                totalSelected: 0,
                rate_card_group: arrayCardGroup
              };
              if (arrayCardGroup.length == 1) {
                obj["totalSelected"] = 1;
                obj["rate_card_group"][0].totalSeatSelected = 1;
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(obj["rate_card_group"][0].rc_total_amount);
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(obj["rate_card_group"][0].rc_net_amount);
                this.totalSeatBooked = this.totalSeatBooked + 1;
              } else if (arrayCardGroup.length > 1) {
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
              }

              array.push(obj);
            }
          });
          this.seatsSelectedRateGroupNew = array;

          if (
            checkCheckoutRateCardNeeded == 0 &&
            array[0]["rate_card_group"].length > 0
          ) {
            console.log("Group Card Not Needed");
            this.$store.dispatch("onSetCompleteRateCard", {
              status: true,
              seatGroup: cloneDeep(this.seatsSelectedRateGroupNew)
            });
            this.$store.dispatch("onSetCompleteNewTotalAmount", {
              totalAmount: this.totalAmountPrice,
              netAmount: this.totalNetAmout
            });
          } else if (checkCheckoutRateCardNeeded > 0) {
            this.$store.dispatch("onSetCompleteRateCard", {
              status: false,
              seatGroup: cloneDeep(this.seatsSelectedRateGroupNew)
            });
          }

          console.log("seats organized into rcg", array);
          return array;
        } else {
          this.seatsSelectedRateGroupNew = [];
          return array;
        }
      } else {
        return this.seatsSelectedRateGroupNew;
      }
    },
    setBookingSeats: function() {
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        // this.errorMessage=`Please Select All Seats`
        this.onSubmitFromRateCardModal();
      } else {
        this.$refs.showRateCard.show();
      }
    },
    onSubmitFromRateCardModal() {
      if (
        !(this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length)
      ) {
        // this.errorMessage=`Please Select All Seats`
        return false;
      }
      // let totalSelectedSeats = this.seatsSelectedRateGroupNew.reduce(
      //   ratecardGroup => ratecardGroup.totalSelected
      // );
      // console.log("onSubmitFromRateCardModal", totalSelectedSeats);
      // if (totalSelectedSeats === this.$store.getters.SELECTED_SEATS.length) {
      //   this.reserveSeats();
      // } else {
      //   this.$toasted.show("select prices for all tickets");
      // }

      this.$store.dispatch("onSetCompleteRateCard", {
        status: true,
        seatGroup: this.seatsSelectedRateGroupNew
      });
      this.$store.dispatch("onSetCompleteNewTotalAmount", {
        totalAmount: this.totalAmountPrice,
        netAmount: this.totalNetAmout
      });
      this.reserveSeats();
      this.$refs.showRateCard.hide();
    },
    async reserveSeats() {
      this.showLoading();
      let reservation_id = Math.floor(100000000 + Math.random() * 900000000);
      await this.$store.dispatch("RESERVE_SEATS_CREATE_SHOW", {
        seat_layout_id: this.$store.getters.seatsSelected,

        cinema_reservation_id: reservation_id,
        aggregator_cinema: this.movieDetails.cine_id,
        cinema_id: this.cinema_id,
        seatGroup: this.seatsSelectedRateGroupNew,
        mycinema_booking_type_id: this.createSchedulePayload.booking_type_id,
        specialRequest: "",
        mycinema_ss_d_id: this.createSchedulePayload.mycinema_ss_d_id
      });

      // const { ss_id } = this.$route.params;
      if (this.$store.getters.seatsSelected.length > 0) {
        this.hideLoading();
        // await this.getAdditionalCharges({
        //   movieDetails: this.schedule_details_obj,
        //   selected_seats: this.seatsSelected,
        //   showDetails: this.schedule_details_obj
        // });
        this.$router.push({
          path: `/payment/${reservation_id}/2`
        });
      } else {
        this.$refs.showRateCard.hide();
        this.showMessage = `Sorry, those seats have already been reserved. Please choose new seats.`;
        this.$refs.SeatRealeased.show();
        this.hideLoading();
      }
    },

    checkForWheelChair: function() {
      let popUpStatus = 0;
      let self = this;
      this.selectedSeats.map((x, index) => {
        if (x.Status == 3 && popUpStatus == 0) {
          //TODO showpopup
          // alert("test");
          this.$refs.WheelChairModal.show();
          // this.count = 0;
          popUpStatus = 1;
          self.count = 0;
        }
      });
    }
  }
};
</script>
<style scoped>
.red-line {
  background: linear-gradient(179.82deg, #e70d00 17.86%, #fa5402 126.35%);
}
.back-txt a {
  font-size: 14px;
  color: #8d99af;
  font-weight: bold;
}
.edit-class {
  font-size: 10px;
  font-style: italic;
  color: #25aad3;
  /* padding-left: 5px; */
  cursor: pointer;
  font-weight: bold;
}
/* CALENDER */
/* .theatre-detail:hover,
   .theatre-detail.active {
   border: 4px solid red;
   border-radius: 15px;
   } */
.calendar .weekdays .day-grid {
  /* display: flex;
   justify-content: center;
   align-items: center; */
  height: 40px;
  width: 40px;
  font-size: 14px;
  color: #212b36;
}
.private-screening-class {
  font-size: 20px;
  margin: 20px 0px;
  color: #2b2d42;
}
.list-inline-item .mr-2 {
  height: 25px;
}
</style>

<style>
:root {
  --primary: #e70d00;
}
.text-red {
  color: var(--red) !important;
}

.section-seat-layout {
  padding: 15px;
  min-height: 95vh;
  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 50px;
  border-radius: 17.5px;
  background-color: #fff;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.seat-layout-header {
  margin-left: -15px;
  margin-right: -15px;
  padding-bottom: 15px;
}

.seat-layout-content {
  padding: 20px;
  overflow: auto;
  height: calc(100% - 250px);
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.seat-layout-content table:not(:last-child) {
  margin-bottom: 30px;
}

.seat-type {
  color: grey;
  font-size: 12px;
  text-align: center;
  padding-bottom: 10px;
}

.seat-layout-footer {
  text-align: center;
}

.seat-information {
  display: flex;
  font-size: 12px;
  margin-top: 15px;
  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
}

.seat-information .seat {
  width: 17.5px;
  height: 17.5px;
  margin-left: 0;
  border-radius: 3px;
}

.seat {
  width: 30px;
  margin: 5px;
  height: 30px;
  color: grey;
  cursor: pointer;
  font-size: 11px;
  padding-top: 6px;
  text-align: center;
  border-radius: 5px;
  border: none;
}

.seat-red {
  width: 30px;
  margin: 5px;
  height: 30px;
  color: red;
  cursor: pointer;
  font-size: 11px;
  padding-top: 6px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid grey;
}

.screen-image {
  height: auto;
  max-width: 90%;
  display: table;
  margin: 0 auto;
  transform: rotate(180deg);
}

.screen-text {
  left: 50%;
  top: calc(50% - 3px);
  z-index: 1;
  color: grey;
  font-size: 10px;
  position: absolute;
  transform: translateX(-50%);
}

.seat.seat-selected {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.seat.seat-unavailable {
  cursor: auto;
  user-select: none;
  background-color: grey;
}

.seat.seat-block {
  cursor: auto;
  user-select: none;
  background-color: #3876d2;
}

.seat-layout-content table {
  margin: 0 auto;
}

.pos-seat-class {
  text-align: center;
}

.pos-seatNumber {
  line-height: 1;
  font-size: 12px;
  padding-bottom: 3px;
  position: relative;
  /* bottom: -5px; */
  text-align: center;
}

.your-selection {
  border-color: var(--seatSelection) !important;
}

.your-selection::after {
  left: 0;
  content: "";
  height: 6px;
  width: 100%;
  bottom: 5px;
  display: block;
  position: absolute;
  transform: rotate(0deg);
  background-color: var(--seatSelection);
}

.rate-grid-col {
  display: grid;
  grid-template-columns: 20% 75%;
  grid-column-gap: 25px;
  align-items: center;
}

.btn-submit-disabled-grey {
  background-color: var(--grey) !important;
  border: 0 !important;
}

@media (max-width: 1300px) {
  .rate-grid-col {
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 25px;
    align-items: center;
  }
  .category {
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 767px) {
  .section-seat-layout {
    height: auto;
  }
  .list-inline-item:not(:last-child) {
    margin-right: 0.3rem;
  }

  .showtime-date {
    width: 90%;
  }
  .rate-grid-col {
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 25px;
    align-items: center;
  }
  .category {
    margin-left: auto;
    margin-right: auto;
  }
  .seat-type .st-name {
    font-size: 1.5rem;
  }
  .h-56 {
    height: 56px;
  }
}
.select-seat-container-myticket .st-name {
  background: whitesmoke;
  color: black;
  padding: 10px;
  margin-bottom: 13px;
  font-size: 18px;
}
.seat-layout-shows {
  width: 85%;
  margin: 0 auto;
}
.seat-layout-shows .slick-next {
  right: -5% !important;
}
.seat-layout-shows .slick-prev {
  left: -5% !important;
}

#seat_select_modal .modal-body {
  background: white !important;
}
.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}
@media only screen and (min-width: 620px) {
  .btn-add-myticket,
  .btn-subtract-myticket,
  .btn-first-add-myticket {
    width: 28px;
    height: 25px;
    color: #000;
    font-size: 14px;
    font-weight: bold;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid var(--primary);
  }
}
.btn-add-myticket.disabled,
.btn-subtract-myticket.disabled {
  background: white;
  color: black;
}
.btn-add-myticket,
.btn-subtract-myticket,
.btn-first-add-myticket {
  width: 35px;
  height: 35px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid var(--primary);
  color: #fff;
  background-color: var(--primary);
}

.btn-add-myticket:hover,
.btn-add-myticket:focus,
.btn-subtract-myticket:hover,
.btn-subtract-myticket:focus,
.btn-first-add-myticket:hover,
.btn-first-add-myticket:focus {
  outline: none;
  /* color: #fff; */
  /* background-color: var(--primary); */
}
.btn-add-myticket:hover,
.btn-add-myticket:focus,
.btn-subtract-myticket:hover,
.btn-subtract-myticket:focus,
.btn-first-add-myticket:hover,
.btn-first-add-myticket:focus {
  outline: none;
  /* color: #fff; */
  /* background-color: var(--primary); */
}

element.style {
}
.select-seat-container-myticket .st-name {
  background: whitesmoke;
  color: black;
  padding: 10px;
  margin-bottom: 13px;
  font-size: 18px;
}
*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
user agent stylesheet div {
  display: block;
}
.select-seat-container-myticket {
  width: 100%;
  overflow: hidden;
  padding-top: 25px;
  text-align: center;
  border-radius: 15px;
  background-color: #fff;
  /* box-shadow: 0px 2px 12px 1px rgb(4 4 4 / 30%); */
}
.w-100px {
  width: 100px;
}
.text-primary-new {
  color: var(--primary) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/specialScreening.vue